import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

const testimonials = [
  {
    name: '追剧达人小王',
    rating: 5,
    comment: '被窝网电影真的太良心了！完全免费而且资源超多，每天晚上躺被窝里追剧已经成了我的日常。画质也很清晰，几乎没有缓冲。',
    date: '2024年6月',
  },
  {
    name: '影视爱好者小李',
    rating: 5,
    comment: '用了很多在线看剧网站，被窝网电影是最好用的。没有弹窗广告，没有强制注册，打开就能看。推荐给了好多朋友，都说好用！',
    date: '2024年7月',
  },
  {
    name: '韩剧迷小张',
    rating: 5,
    comment: '特别喜欢在这里看韩剧，更新速度很快，基本上韩国那边刚播完这边就有了。翻译质量也不错，追剧体验一级棒。',
    date: '2024年8月',
  },
  {
    name: '全职妈妈刘女士',
    rating: 4,
    comment: '带娃之余最大的乐趣就是追剧了。被窝网电影的电视剧资源特别全，想看的剧基本都能找到，而且是全集播放，不用一集集等更新。',
    date: '2024年9月',
  },
  {
    name: '大学生小陈',
    rating: 5,
    comment: '被窝网电影是我们宿舍的快乐源泉！晚上熄灯后大家一起追剧，讨论剧情，氛围特别好。而且手机端看也很流畅，太方便了。',
    date: '2024年10月',
  },
  {
    name: '上班族赵先生',
    rating: 5,
    comment: '通勤路上用手机看剧，回家用电脑接着看，数据同步很方便。被窝网电影真的是上班族的解压神器，每天下班追一集神清气爽。',
    date: '2024年11月',
  },
];

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于被窝网电影',
    description: '被窝网电影是一个免费高清电视剧在线观看平台，提供国产剧、韩剧、美剧、日剧、动漫、综艺等丰富资源。',
    about: {
      '@type': 'Organization',
      name: '被窝网电影',
      description: '被窝网电影 - 电视剧全集免费高清在线观看平台',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '被窝网电影',
    url: 'https://www.beiwodianying.com/',
    description: '免费高清电视剧在线观看平台，提供丰富的电视剧资源，包括国产剧、韩剧、美剧、日剧、动漫、综艺等。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'service@beiwodianying.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <main>
        <Navbar />
        <div className="pt-20 pb-4 bg-background-100">
          <div className="max-w-7xl mx-auto w-full">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        {/* Hero */}
        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto w-full text-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-primary-100 rounded-2xl">
              <i className="ri-movie-line text-3xl text-primary-600"></i>
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
              关于被窝网电影
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              被窝网电影是一个专注于免费高清电视剧在线观看的平台，致力于为广大影视爱好者提供优质的追剧体验。
              我们聚合了丰富的电视剧资源，涵盖国产剧、韩剧、美剧、日剧、动漫、综艺等多个分类，
              让每一位用户都能在被窝里享受流畅不缓冲的追剧时光。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto w-full">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-6 flex items-center gap-3">
              <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
              品牌故事
            </h2>
            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                被窝网电影诞生于2020年，创始团队是一群热爱影视的年轻人。我们深知追剧时最让人烦恼的是什么——缓冲卡顿、广告弹窗、需要付费。
                于是我们决定打造一个真正为用户着想的电视剧观看平台。
              </p>
              <p>
                经过多年的发展壮大，被窝网电影已经成为国内领先的免费电视剧资源聚合平台。
                我们始终坚守"免费、高清、不缓冲"的初心，每天为数十万用户提供优质的追剧服务。
              </p>
              <p>
                从最初的几十部资源到如今的海量片库，从单一的分类到涵盖多语种、多类型的内容矩阵，
                被窝网电影的每一步成长都离不开用户的信任与支持。
              </p>
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto w-full">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
              我们的核心优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-accent-100 text-accent-600 rounded-xl">
                  <i className="ri-money-cny-circle-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">完全免费</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  无需充值，无需会员，打开即可观看全集。我们承诺永远不对用户收费。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl">
                  <i className="ri-4k-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">高清画质</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  所有资源均提供高清画质，配合CDN加速技术，流畅不缓冲。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-xl">
                  <i className="ri-global-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">资源丰富</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  聚合海量电视剧资源，涵盖六大分类，每日更新热门剧集。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-accent-100 text-accent-600 rounded-xl">
                  <i className="ri-speed-up-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">极速更新</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  热播剧同步更新，第一时间为您呈现最新剧集内容。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl">
                  <i className="ri-smartphone-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">全平台支持</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  电脑、平板、手机全适配，随时随地轻松追剧无压力。
                </p>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-xl">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">安全可靠</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  干净的观看环境，无恶意弹窗，保护您的追剧体验和个人隐私。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto w-full">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, j) => (
                      <i
                        key={j}
                        className={`ri-star-fill text-sm ${
                          j < t.rating ? 'text-accent-500' : 'text-foreground-200'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-3">
                    &ldquo;{t.comment}&rdquo;
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-foreground-800 text-xs font-medium">{t.name}</span>
                    <span className="text-foreground-400 text-xs">{t.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto w-full">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <a
                  href="mailto:service@beiwodianying.com"
                  className="text-foreground-500 hover:text-primary-600 text-sm transition-colors cursor-pointer"
                >
                  service@beiwodianying.com
                </a>
              </div>
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 text-accent-600 rounded-xl">
                  <i className="ri-customer-service-2-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1">在线客服</h3>
                <p className="text-foreground-500 text-sm">
                  工作日 9:00 - 18:00
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}